import React, { useState, useCallback } from 'react';
import BulkActionModal from '../BulkActionModal';

interface BulkRecordedDateModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedCount: number;
  onConfirm: (newRecordedDate: string) => Promise<void>;
  isAllFiltered?: boolean; // True if "Select All (X)" was used
  totalFilteredCount?: number; // Total count when isAllFiltered is true
}

const BulkRecordedDateModal: React.FC<BulkRecordedDateModalProps> = ({
  isOpen,
  onClose,
  selectedCount,
  onConfirm,
  isAllFiltered = false,
  totalFilteredCount = 0
}) => {
  const [recordedDate, setRecordedDate] = useState<string>('');

  // Reset the field each time the modal opens.
  React.useEffect(() => {
    if (isOpen) {
      setRecordedDate('');
    }
  }, [isOpen]);

  const handleDateChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setRecordedDate(e.target.value);
  }, []);

  return (
    <BulkActionModal
      isOpen={isOpen}
      onClose={onClose}
      title="Change Recorded Date"
      verb="Set the recorded date of"
      connector="to:"
      selectedCount={selectedCount}
      isAllFiltered={isAllFiltered}
      totalFilteredCount={totalFilteredCount}
      canConfirm={!!recordedDate}
      onConfirm={() => onConfirm(recordedDate)}
      hint="The recorded date controls which budget period each invoice is attributed to. The date shown on the invoice itself is not changed."
    >
      <label className="bulk-action-modal__label" htmlFor="bulk_recorded_date">New Recorded Date</label>
      <input
        id="bulk_recorded_date"
        type="date"
        value={recordedDate}
        onChange={handleDateChange}
      />
    </BulkActionModal>
  );
};

export default BulkRecordedDateModal;
